import { render, staticRenderFns } from "./AnswerFree.vue?vue&type=template&id=ea685ba0&scoped=true&"
import script from "./AnswerFree.vue?vue&type=script&lang=ts&"
export * from "./AnswerFree.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea685ba0",
  null
  
)

export default component.exports